import { useRef } from "react";

/** Mantém a identidade do valor enquanto o conteúdo (por `JSON.stringify`) é o mesmo. */
export function useStableValue<T>(value: T): T {
  const key = JSON.stringify(value);
  const stable = useRef({ key, value });
  if (stable.current.key !== key) stable.current = { key, value };
  return stable.current.value;
}
